var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { darken, transparentize } from 'polished';
import React from 'react';
import { css, styled } from "../../utils";
import Button, { ButtonProps } from "./Button";
var StyledButton = styled(Button)(function (_a) {
    var colors = _a.theme.colors, _b = _a.selected, selected = _b === void 0 ? false : _b;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: ", ";\n    background-color: ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-transform: none;\n    margin: 1rem 0;\n\n    &&:hover {\n      color: ", ";\n      font-weight: 500;\n      background-color: ", ";\n    }\n  "], ["\n    color: ", ";\n    font-weight: ", ";\n    background-color: ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-transform: none;\n    margin: 1rem 0;\n\n    &&:hover {\n      color: ", ";\n      font-weight: 500;\n      background-color: ", ";\n    }\n  "])), colors.black, selected ? 600 : 500, selected ? transparentize(0.85, colors.primary) : colors.white, colors.white, darken(0.05, colors.primary));
});
var SelectButton = function (props) { return (React.createElement(StyledButton, __assign({ "data-component": "SelectButton", block: true, outline: true }, props))); };
export default SelectButton;
var templateObject_1;
//# sourceMappingURL=SelectButton.js.map